/**
 * Os rotulos em portugues dos enums da anamnese, transcritos de
 * `utills/Translate.tsx` da referencia.
 *
 * Fica na apresentacao, e nao na view: e vocabulario do DOMINIO - "SMOKE" e "Fuma"
 * na mesma frase, e quem sabe disso e quem conhece o backend. A view so desenha o
 * texto que recebe.
 *
 * Cada funcao devolve o proprio valor quando nao conhece a chave, como la: um enum
 * novo aparece cru na tela em vez de desaparecer.
 */
function of(table, value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    return table[value] ?? value;
}
export function sexLabel(value) {
    return of({ MALE: 'Masculino', FEMALE: 'Feminino', OTHER: 'Outro' }, value);
}
export function physicalActivityLabel(value) {
    return of({ YES: 'Sim', NO: 'Não' }, value);
}
export function daysOfActivityLabel(value) {
    return of({
        ONE_TO_TWO_DAYS: '1 a 2 dias por semana',
        THREE_TO_FOUR_DAYS: '3 a 4 dias por semana',
        FIVE_TO_SIX_DAYS: '5 a 6 dias por semana',
        EVERY_DAY_INCLUDING_SATURDAY_AND_SUNDAY: 'Todos os dias (inclusive sáb. e dom.)',
        ALMOST_NEVER: 'Quase nunca',
        NEVER: 'Nunca',
        DONT_KNOW_TELL: 'Não sabe dizer'
    }, value);
}
export function smokingLabel(value) {
    return of({ SMOKE: 'Fuma', DONT_SMOKE: 'Não fuma' }, value);
}
export function alcoholLabel(value) {
    return of({
        MORE_THAN_ONE_DAY_PER_WEEK: 'Mais de um dia por semana',
        LESS_THAN_ONE_DAY_PER_WEEK: 'Menos de 1 dia por semana',
        LESS_THAN_ONE_DAY_PER_MONTH: 'Menos de 1 dia por mês',
        DONT_DRINK: 'Não consome bebida alcoólica'
    }, value);
}
export function healthStateLabel(value) {
    return of({
        VERY_GOOD: 'Muito bom',
        GOOD: 'Bom',
        REGULAR: 'Regular',
        BAD: 'Ruim',
        VERY_BAD: 'Muito ruim'
    }, value);
}
export function medicalConsultationsLabel(value) {
    return of({
        AT_LEAST_ONCE_PER_YEAR: 'Pelo menos uma vez por ano, independente de algum problema de doença',
        ONLY_ON_EMERGENCY: 'Somente quando ocorre alguma emergência de doença'
    }, value);
}
export function healthPlanLabel(value) {
    return of({
        PRIVATE_OR_CORPORATE: 'Plano de saúde privado particular ou corporativo (da empresa)',
        SUS: 'Assistência única pelo SUS e rede pública municipal e estadual',
        DONT_KNOW_OR_DONT_ANSWER: 'Não sabe/ não respondeu'
    }, value);
}
export function mouthHealthLabel(value) {
    return of({
        ONE: 'Um',
        TWO: 'Dois',
        THREE: 'Três',
        FOUR: 'Quatro',
        FIVE_OR_MORE: 'Cinco ou mais',
        DONT_REMENBER: 'Não lembra'
    }, value);
}
//# sourceMappingURL=anamnese-labels.js.map